import { AntDesign } from "@expo/vector-icons";
import { Pressable } from "react-native";
import { Spacings, View } from "react-native-ui-lib";
import { Text } from "@towersystems/roam-common-native";
import { useTheme } from "@towersystems/roam-common-native";

export interface ButtonProps {
  onPress(): void;
  disabled?: boolean;
  label: string;
  description?: string;
  icon?: React.ReactNode;
  componentRight?: (icon: React.ReactNode) => React.ReactNode;
  selected?: boolean;
}

export const Button = ({
  onPress,
  disabled,
  label,
  description,
  icon,
  selected,
  componentRight,
}: ButtonProps) => {
  const { colors } = useTheme();

  const textStyles = [
    {
      fontSize: 22,
      color: colors.text,
    },
    selected && { color: colors.action },
  ];

  const descriptionMarkup = description ? (
    <Text
      numberOfLines={1}
      ellipsizeMode="head"
      style={{ opacity: 0.5, fontSize: 16 }}
    >
      {description}
    </Text>
  ) : null;

  const iconMarkup = icon ? (
    <View style={{ marginRight: Spacings.s5 }}>{icon}</View>
  ) : undefined;

  const iconNode = (
    <Text style={textStyles}>
      <AntDesign style={{ marginLeft: Spacings.s4 }} name="right" size={24} />
    </Text>
  );

  const componentRightMarkup = componentRight
    ? componentRight(iconNode)
    : iconNode;

  return (
    <Pressable
      disabled={disabled}
      onPress={onPress}
      style={[{ padding: Spacings.s4 }, disabled ? { opacity: 0.4 } : {}]}
    >
      <View flex row style={{ justifyContent: "space-between" }}>
        <View style={{ flexBasis: "100%", flexShrink: 1 }} centerV row>
          {iconMarkup}
          <View style={{ flexShrink: 1 }}>
            <Text numberOfLines={1} ellipsizeMode="head" style={textStyles}>
              {label}
            </Text>
            {descriptionMarkup}
          </View>
        </View>
        <View>{componentRightMarkup}</View>
      </View>
    </Pressable>
  );
};
